import axios, { AxiosRequestConfig } from 'axios'
import convertToSnakeCase from '@Utils/ConvertToSnakeCase'

import {
  IStartQuickstartProcessingPayload,
} from './types'

const config: AxiosRequestConfig = {
  responseType: 'json'
}

export function fetchQuickstartSettings() {
  return axios.get('/api/v1/project_versions/show_settings_quickstart')
}

export function startQuickstartProcessing(payload: IStartQuickstartProcessingPayload) {
  return axios.put(`/api/v1/project_versions/setup_quickstart`, convertToSnakeCase(payload), config)
}

export function finishSurvey() {
  return axios.put('/api/v1/users/finish_survey', null, config)
}

export function getForwardingPath() {
  return axios.get('/api/v1/users/show_onboarding_forwarding_path')
}
